import React from 'react';
import { observer } from 'mobx-react';

import { WidgetRow } from 'src/libs/ui-kit/widget-row/WidgetRow';

import { widgetLabels } from '../constants';

import { useProfileWidgetStore } from './StoreProvider';

export const IdRow = observer(() => {
  const { profile } = useProfileWidgetStore();
  return <WidgetRow label={widgetLabels.userNumber} value={profile?.id} />;
});
